import React from 'react';
import AccountService from '../../service/AccountService';
import { RouterStore } from 'mobx-react-router';
import { inject } from 'mobx-react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Card,
  CardActions,
  Button,
  CardActionArea,
} from '@mui/material';
import LogoutButton from '../common/LogoutButton';
import BackIcon from '@mui/icons-material/ArrowBack';
import autobind from 'autobind-decorator';
import FavoriteIcon from '@mui/icons-material/Favorite';

type PlanSuccessProps = {
  routing?: RouterStore;
  account?: AccountService;
  match?: any;
};

@inject('account')
@inject('routing')
export default class PlanSuccess extends React.Component<PlanSuccessProps> {
  @autobind
  goBack() {
    var { account } = this.props;
    account.goBack();
  }

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            width: '100%',
            height: 'env(safe-area-inset-top)',
            backgroundColor: '#3f51b5',
          }}
        />
        <AppBar position="static">
          <Toolbar variant="dense">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={this.goBack}
            >
              <BackIcon />
            </IconButton>
            <Typography variant="h6" style={{ flexGrow: 1, color: 'inherit' }}>
              Flows Subscription Successful
            </Typography>
            {this.props.account.user ? <LogoutButton /> : null}
          </Toolbar>
        </AppBar>
        <Card
          style={{
            margin: '20px',
            padding: '30px',
            minWidth: '200px',
            textAlign: 'center',
            borderRadius: '15px',
          }}
        >
          <CardActionArea>
            <FavoriteIcon fontSize="large" color="secondary"></FavoriteIcon>
            <Typography
              gutterBottom
              component="h1"
              style={{
                color: '#444F60',
                fontSize: '36px',
                fontWeight: 'normal',
                fontStyle:
                  '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
              }}
            >
              Thank You
            </Typography>
            <Typography
              gutterBottom
              component="h1"
              style={{
                color: '#444F60',
                fontSize: '36px',
                fontWeight: 'normal',
                fontStyle:
                  '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
              }}
            >
              Your payment was successful.
            </Typography>
            <Typography variant="body2" color="textSecondary" component="div">
              You can now go ahead to create more Flows and gather more
              feedback.
            </Typography>
          </CardActionArea>
          <CardActions style={{ justifyContent: 'center', marginTop: '30px' }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => this.props.routing.replace('/')}
            >
              OK!
            </Button>
          </CardActions>
        </Card>
      </React.Fragment>
    );
  }
}
